<template>
  <div class="product">
    <el-tabs class="elTabs" v-model="activeName" @tab-click="handleClick">
        <product-first></product-first>
    </el-tabs>
  </div>
</template>

<script>
import { categoryread } from "@/api";
import ProductFirst from "./productFirst.vue";
export default {
  components: { ProductFirst },
  data() {
    return {
      activeName: "光学元件",
      erjicaidan:[],
      sanjicaidan:[],
    };
  },
  
  computed: {
    productGoods() {
    return this.$store.state.productTabs
    }
  },
  watch: {
  "$store.state.productTabs": function(newV) {
    if(newV.length) {
      this.activeName = newV[0].name;
    }
  }
  },
  mounted(){
  },
  methods: {
    handleClick(tab, event) {
    }
  }
};
</script>

<style lang="less" scoped>
.product {
  margin: -50px 0 0;
  position: relative;
  z-index: 100;
  padding: 0 18%;
}
.elTabs {
  background-image: url('/static/home/bg-product.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 1rem;

  /deep/ .el-tabs__item {
    color: #4d4d4d;
  }
  /deep/ .el-tabs__header {
    background: #f0f0f0;
    padding: 0 1.75rem;
  }
  /deep/ .el-tabs__content {
    border-radius: 1rem;
  }
  /deep/ .el-tabs__header {
    margin: 0;
  }
  /deep/ .el-tabs__nav-wrap::after {
    height: 0px;
  }
  /deep/ .el-tabs__item.is-active {
    color: #635796;
  }
  /deep/ .el-tabs__active-bar {
    background-color: #635796;
    height: 6px;
  }
}
</style>
